import { useLive } from "../../api/queries/useLive";
import { useWelcome } from "../../api/queries/useWelcome";

export default function Homepage() {
  const { data: welcome } = useWelcome()
  // eslint-disable-next-line
  const { data: live } = useLive()

  return (
    <div className={"row"}>
      <div className={"col-12"} dangerouslySetInnerHTML={{ __html: welcome?.html || "" }} />
    </div>
  )
}
